import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card, message, Popconfirm, Table } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ContentWithErrorHandler from '../../app/ContentWithErrorHandler';
import { basicSort, TableColumnTextFilterConfig } from '../../common/TableHelper';
import { useDeletePoolMutation, useGetAllPoolsQuery } from './lotteryAPI';
import { LotteryPool } from './lotteryAPI';

function LotteryPoolList() {
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetAllPoolsQuery();
  const [deletePool] = useDeletePoolMutation();

  const handleDelete = async (id: number) => {
    try {
      await deletePool(id).unwrap();
      message.success('Data undian berhasil dihapus');
    } catch (err: any) {
      message.error(err.data?.message || 'Gagal menghapus data undian');
    }
  };

  return (
    <ContentWithErrorHandler isError={error} isLoading={false}>
      <Card
        title="Data Undian"
        size="small"
        extra={
          <div>
            <Button type="primary" style={{ borderRadius: 5 }}>
              <Link to="create">+ Tambah Undian</Link>
            </Button>
          </div>
        }
      >
        <Table
          loading={isLoading}
          dataSource={data}
          rowKey="id"
          bordered
          size="small"
          pagination={{ pageSize: 10 }}
          columns={[
            {
              title: 'Nama Undian',
              dataIndex: 'name',
              key: 'name',
              width: '25%',
              sorter: (a, b) => basicSort(a.name, b.name),
              ...TableColumnTextFilterConfig<LotteryPool>('name'),
            },
            {
              title: 'Deskripsi',
              dataIndex: 'description',
              key: 'description',
              width: '40%',
              sorter: (a, b) => basicSort(a.description || '', b.description || ''),
              render: (description: string) => (
                <div dangerouslySetInnerHTML={{ __html: description || '' }} style={{ wordBreak: 'break-word', whiteSpace: 'normal' }} />
              ),
            },
            {
              title: 'Aktif',
              dataIndex: 'isActive',
              key: 'isActive',
              width: '10%',
              render: (isActive: boolean) => (isActive ? 'Ya' : 'Tidak'),
            },
            {
              title: 'Aksi',
              key: 'actions',
              width: '20%',
              render: (_, record) => (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <Button type="link" block onClick={() => navigate(`edit/${record.id}`)}>
                    Edit Undian
                  </Button>
                  <Button type="link" block onClick={() => navigate(`categories/${record.id}`)}>
                    Edit Kategori
                  </Button>
                  <Popconfirm title="Hapus Undian" onConfirm={() => handleDelete(record.id)} okText="Ya" cancelText="Tidak">
                    <Button type="link" danger block>
                      Hapus Undian
                    </Button>
                  </Popconfirm>
                </div>
              ),
            },
          ]}
        />
      </Card>
    </ContentWithErrorHandler>
  );
}

export default LotteryPoolList;
